import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import Input from "components/Input";
import { useState } from "react";
import Button from "components/Button";
import classNames from "classnames";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CompanyData: FC<Props> = ({ data, nextStep }) => {
  const { t } = useTranslation();
  const [chooseRegisterMethodError] = useState(false);
  const [approveRules, setApproveRules] = useState(false);

  const AcceptRulesRegion = () => {
    return (
      <div className={styles.checkbox}>
        <FormControl required error={chooseRegisterMethodError}>
          <FormGroup>
            <FormControlLabel
              required
              control={
                <Checkbox
                  checked={approveRules}
                  onChange={(e) => setApproveRules(e.target.checked)}
                />
              }
              label={
                <span className={styles.rules}>
                  {t("companyData.acceptRulesPart1")}{" "}
                  <a href="https://notaup.pl/regulamin" target="_blank">
                    {t("companyData.termsOfService")}
                  </a>
                  ,{" "}
                  <a
                    href="https://notaup.pl/politykaPrywatnosci"
                    target="_blank"
                  >
                    {t("companyData.acceptRulesPart2")}{" "}
                  </a>{" "}
                  {t("companyData.acceptRulesPart3")}
                  <a
                    href="https://notaup.pl/umowaPowierzeniaDanych"
                    target="_blank"
                  >
                    {" "}
                    {t("companyData.dataProcessingAgreement")}
                  </a>{" "}
                  {t("companyData.acceptRulesPart4")}
                </span>
              }
            ></FormControlLabel>
            {chooseRegisterMethodError && (
              <div className={styles.errorBlock}>
                {t("companyData.requiredRulesAcceptance")}
              </div>
            )}
          </FormGroup>
        </FormControl>
      </div>
    );
  };

  const [nextButtonState] = useState({
    show: true,
    label: t("common.next"),
    disabled: false,
  });

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.title}>
            {t("companyData.boardMemberConsentTitle")}
          </div>
          <div className={styles.side}>
            {t("companyData.boardMemberDesc1")}{" "}
            <b>
              {data.FirstName} {data.LastName}
            </b>{" "}
            {t("companyData.boardMemberDesc2")} <b>{data.CompanyName}</b>.
          </div>
          <div className={styles.side}></div>
          <div className={styles.side}>
            {t("companyData.boardMemberDesc3")}
          </div>
        </div>

        <div className={styles.form}>
          <Input
            type="text"
            label={t("forms.companyName")}
            value={data?.CompanyName}
            disabled={true}
            onChange={() => {}}
          ></Input>

          <Input
            type="text"
            label="NIP"
            placeholder="NIP"
            disabled={true}
            value={data?.Nip}
            onChange={() => {}}
          ></Input>

          <div className={styles.personHeader}>
            {t("companyData.processStartedBy")}
          </div>
          <Input
            type="text"
            label={t("forms.firstName")}
            value={data?.FirstName}
            onChange={() => {}}
            disabled={true}
            RightIcon={
              <div className={classNames(styles.verification, styles.verified)}>
                {t("identity.verifiedData")}
              </div>
            }
          ></Input>
          <Input
            type="text"
            label={t("forms.lastName")}
            value={data?.LastName}
            onChange={() => {}}
            disabled={true}
            RightIcon={
              <div className={classNames(styles.verification, styles.verified)}>
                {t("identity.verifiedData")}
              </div>
            }
          ></Input>
        </div>

        <AcceptRulesRegion></AcceptRulesRegion>

        <div className={styles.buttons}>
          {nextButtonState.show && (
            <Button
              className={styles.button}
              text={nextButtonState.label}
              disabled={!approveRules}
              onClick={() => nextStep?.()}
            ></Button>
          )}
        </div>
      </div>
    </>
  );
};

export default CompanyData;
